
























    import PackagePromo from '@/components/PackagePromo.vue';
    import Precalculations from '@/components/Precalculations.vue';
    import SideToolbar from '@/components/SideToolbar.vue';
    import Http from '@/mixins/http';
    import LocalData from '@/mixins/local-data';
    import {BTabs} from 'bootstrap-vue';
    import {Component, Mixins} from 'vue-property-decorator';
    import PackageCalc from './PackageCalc.vue';
    import ScheduleCalculator from './ScheduleCalculator.vue';
    import CartsScheduleCalculator from './CartsScheduleCalculator.vue';

    @Component({
        components: {Precalculations, PackageCalc, PackagePromo, ScheduleCalculator, CartsScheduleCalculator, SideToolbar},
    })
    export default class PackageAndSchedule extends Mixins(LocalData, Http) {
        tabs: BTabs | null = null;

        hidePackagePromoPanel(): boolean {
            return this.$disallowedModules.includes('package-promo');
        }

    mounted() {
        this.tabs = this.$refs.mainTabs as BTabs
    }

}
